module.exports = __webpack_public_path__ + "media/images/icons/filled/tag-c6dd43d833fa4303ab5e6aee99b83a99.svg";